import { useMutation } from '@apollo/client/react';
import { metrics } from '@seek/metrics-js';
import { useCallback } from 'react';

import { gql } from 'src/__generated__';
import { useConfig } from 'src/context/config';
import { logError } from 'src/modules/error-logger/browserLog';

export const REQUEST_RESUME_PARSING = gql(`
  mutation RequestResumeParsing($input: RequestResumeParsingInput!) {
    requestResumeParsing(input: $input) {
      ref
    }
  }
`);

export function useResumeParsing() {
  const { config } = useConfig();

  const [request] = useMutation(REQUEST_RESUME_PARSING, {
    onError(error, clientOptions) {
      metrics.count('resume-parsing-unexpected-error');
      logError(
        { ...error, type: 'resume-parsing-unexpected-error' },
        clientOptions?.variables,
      );
    },
  });

  const requestResumeParsing = useCallback(
    (resumeId: string) => {
      request({
        variables: {
          input: {
            id: resumeId,
            parsingContext: { id: resumeId },
            zone: config.ZONE,
          },
        },
      });
    },
    [request, config.ZONE],
  );

  return { requestResumeParsing };
}
